import React, { Component, Fragment } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';


import './auth.scss';

// Auth: Common
import { Navbar } from './_common/navbar';

// Auth: Views
import { Signup } from './signup';
import { Signin } from './signin';
import { Referent } from './referent';
import Identity from './identity';
import { PasswordIndex } from './password';
import * as R from 'ramda';
import *  as axios from 'axios';
import { Code } from './signin/code';
import { PartnerIndex } from './partner';
import { PartnerSignup } from './partner/onboarding';



export const App = () => {

  const location = useLocation();
  let authToken = sessionStorage.getItem("access_token");
  if (!R.isNil(authToken)) {
    axios.defaults.headers.common['Authorization'] = "Bearer " + authToken;
  }

  const color = new URLSearchParams(location.search).get("color");
  const partnerId = new URLSearchParams(location.search).get("partnerId");

  return (
    <Switch>
      <Route path="/auth/signup" component={Signup} />
      <Route path="/auth/partner/signup" component={PartnerSignup} />
      <Fragment>
        <div className={"layout layout-col" + (!R.isNil(color) && color !== "" ? "" : " bg-gradient-primary")} style={{ backgroundColor: "#" + color }}>
          <h1 className="sr-only visually-hidden">Assist@</h1>
          <Navbar partnerId={partnerId} partnerColor={"#" + color} />
          <Switch>
            <Route exact path="/auth/signin" component={Signin} />
            <Route exact path="/auth/signin/code" component={Code} />
            <Route path="/auth/identity/" component={Identity} />
            <Route path="/auth/password" component={PasswordIndex} />
            <Route path="/auth/referent" component={Referent} />
            <Route path="/auth/partner" component={PartnerIndex} />
            <Route render={() => {
              return <Redirect to="/auth/signin" />;
            }} />
          </Switch>
        </div>
        <ToastContainer />
      </Fragment>
    </Switch>
  );
};

export default App;
